<template>
  <div>

    <form @submit.prevent="submit">
      <p class="text-muted">Informe o número do seu documento</p>

      <div class="form-group">
        <FloatingLabel v-if="!isForeign" type="tel" input-class="form-control form-control-xl bg-light-2 border-0" label="CPF" v-model="document" v-mask="'###.###.###-##'" v-on:blur="checkDocument" />
        <FloatingLabel v-if="isForeign" type="tel" input-class="form-control form-control-xl bg-light-2 border-0" label="RNE" v-model="document" v-mask="'XXXXXXXXXXXXXXXXXXXXXXXXXXXX'" v-on:blur="checkDocument" />
        <small class="form-text text-danger" v-if="documentMessage">{{ documentMessage }}</small>
      </div>

      <div class="custom-control custom-checkbox custom-checkbox-lg custom-checkbox-background mb-5">
        <input type="checkbox" class="custom-control-input" id="foreign" v-model="isForeign">
        <label class="custom-control-label" for="foreign">Sou estrangeiro</label>
      </div>

      <div class="text-center">
        <button type="submit" class="btn btn-wl-secondary btn-block" :disabled="!disabledForm">Criar Usuário</button>
        <a href="#" class="text-wl-secondary d-inline-block mt-3" @click.prevent="$emit('changeModal', 'define')">Voltar</a>
      </div>
    </form>

  </div>
</template>

<script>
  import FloatingLabel from '@/components/FloatingLabel';

  export default {
    name: 'DocumentForm',

    data(){
      return {
        isForeign: false,
        document: '',
        documentMessage: null
      }
    },

    computed: {
      disabledForm(){
        return (this.isForeign && this.document.length > 5) || (!this.isForeign && this.$helpers.isCPF(this.document))
      }
    },

    components: {
      FloatingLabel
    },

    watch: {
      // Limpa documento quando muda a flag de estrangeiro
      isForeign: function(newValue, oldValue){
        this.document = ''
        this.documentMessage = null
      },
    },

    methods: {
      checkDocument(){
        if( !this.isForeign ){
          this.documentMessage = this.$helpers.isCPF(this.document) ? null : 'CPF inválido';
        }else{
          this.documentMessage = this.document.length > 5 ? null : 'RNE inválido'
        }
      },

      submit(){
        let current_profile = this.$store.state.deviseTrying;
        current_profile.isForeign = this.isForeign;
        current_profile.document = this.document;
        this.$store.commit('DEVISE_TRYING', current_profile);

        this.$emit('signUp');
      }
    },
  }
</script>

<style lang="scss"></style>